import { IRectangle, List } from "@fluentui/react";
import { HomePageLinkType } from "../../products/models/ProductModel";
import { ContextualMenuItem } from "../models/OtherTypes"

export type TopBrandProps = {
    brands: ContextualMenuItem[];
}

export default function TopBrandView({ brands }: TopBrandProps) {
    var columnCount: number = 2;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            let count = 2;

            const width = surfaceRect?.width ?? 0;
            count = Math.trunc(width / 220);

            if (count < 2) count = 2;

            columnCount = count;
        }

        return brands.length;
    }

    const onSelect = (brand: ContextualMenuItem) => {
        window.open(`/products?type=${HomePageLinkType.quickLink}&&key=${brand.key}`, "_self");
    }

    const onRenderCell = (brand?: ContextualMenuItem, index?: number, isScrolling?: boolean) => {
        if (!brand) {
            return <div></div>;
        }

        const width = (100 / columnCount) + '%';

        return <div key={brand.id} className="list-grid-tile p-10 cursor" style={{ width: width }}>
            <div onClick={() => onSelect(brand)} className={"box pv-10 center"}>
                {brand.text}
            </div>
        </div>;
    }

    return <div>
        <List
            items={brands}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}